/**
 * @generated SignedSource<<fa0aeb4020a8b36db0f191ecc587bb4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedSellerDetails_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_viewer" | "PdpSharedSellerDetailsReviewContainer_viewer" | "PdpSharedSellerTabs_viewer">;
  readonly " $fragmentType": "PdpRespSharedSellerDetails_viewer";
};
export type PdpRespSharedSellerDetails_viewer$key = {
  readonly " $data"?: PdpRespSharedSellerDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSellerDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedSellerDetails_viewer",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContactDealerInlineForm_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerTabs_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerDetailsReviewContainer_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "96992d2f540fc20f185d2b02bcdaf769";

export default node;
